"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var VideoElement = styled_components_1.default.video(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\toutline: none;\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\toutline: none;\n"])));
var Play = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tz-index: 2;\n\tposition: absolute;\n\ttop: calc(50% - 75px);\n\tright: auto;\n\tleft: calc(50% - 50px);\n\n\twidth: 100px;\n\theight: 100px;\n\tbackground: rgba(0,0,0,0.5);\n\tborder-style: none;\n\tborder-radius: 50%;\n\toutline: none;\n\tcolor: #fff;\n\tcursor: pointer;\n\t\n\tuser-select: none;\n\t\n\toverflow: visible;\n\n\t::after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 54%;\n\t\ttransform: translate(-50%,-50%);\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-color: transparent transparent transparent #fff;\n\t\tborder-style: solid;\n\t\tborder-width: 20px 0 20px 28px;\n\t}\n"], ["\n\tz-index: 2;\n\tposition: absolute;\n\ttop: calc(50% - 75px);\n\tright: auto;\n\tleft: calc(50% - 50px);\n\n\twidth: 100px;\n\theight: 100px;\n\tbackground: rgba(0,0,0,0.5);\n\tborder-style: none;\n\tborder-radius: 50%;\n\toutline: none;\n\tcolor: #fff;\n\tcursor: pointer;\n\t\n\tuser-select: none;\n\t\n\toverflow: visible;\n\n\t::after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tleft: 54%;\n\t\ttransform: translate(-50%,-50%);\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-color: transparent transparent transparent #fff;\n\t\tborder-style: solid;\n\t\tborder-width: 20px 0 20px 28px;\n\t}\n"])));
var Video = /** @class */ (function (_super) {
    __extends(Video, _super);
    function Video() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            ready: false
        };
        _this.control = react_1.default.createRef();
        _this.play = function () {
            var video = _this.control.current;
            if (video) {
                video.play();
            }
        };
        _this.stop = function () {
            var video = _this.control.current;
            if (video) {
                video.pause();
            }
        };
        _this.playing = function () {
            _this.setState({ ready: false });
        };
        _this.ready = function () {
            _this.setState({ ready: true });
        };
        return _this;
    }
    Video.prototype.render = function () {
        var _a;
        return (react_1.default.createElement("div", { style: { width: "100%", height: "100%", outline: "none" } },
            react_1.default.createElement(VideoElement, { ref: this.control, src: typeof (this.props.source) === "string" ? this.props.source : undefined, poster: this.props.placeholder, preload: "metadata", onPlaying: this.playing, onCanPlay: this.ready, onEnded: this.ready, onPause: this.ready, onClick: this.stop },
                typeof (this.props.source) !== "string" && ((_a = this.props.source) === null || _a === void 0 ? void 0 : _a.map(function (src) { return (react_1.default.createElement("source", { src: src.url, type: src.mimetype })); })),
                this.props.unsupported),
            this.state.ready &&
                react_1.default.createElement(Play, { onClick: this.play })));
    };
    return Video;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Video);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Video.js.map